module.exports = __webpack_public_path__ + "8f8f31b3078679504130dd3536ab84a8.png";